import { render, staticRenderFns } from "./FormLayoutAdd.vue?vue&type=template&id=31173024&"
import script from "./FormLayoutAdd.vue?vue&type=script&lang=js&"
export * from "./FormLayoutAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports